<template>
  <div class="md:px-32 py-8 w-full">
    <div class="bg-gray-800">
      <div class="shadow rounded border-b border-gray-200">
        <div
          class="bg-white border m-5 mt-5 rounded-sm inline flex my-2 rounded"
        >
          <input
            class="border-2 w-full rounded-mb"
            v-model="buscar"
            @keyup.enter="buscador"
            type="text"
            placeholder="   Buscar"
          />
          <button>
            <img
              class="p-1 mt-1 fill-current text-green-600"
              width="35px"
              height="20px"
              src="https://svgsilh.com/svg_v2/1093183.svg"
              alt="X"
            />
          </button>
        </div>
        <table class="min-w-full uppercase bg-white">
          <thead class="bg-gray-800 text-white">
            <tr>
              <th
                class="
                  w-1/3
                  text-left
                  py-3
                  px-4
                  uppercase
                  font-semibold
                  text-sm
                "
              >
                ID
              </th>
              <th
                class="
                  w-1/3
                  text-left
                  py-3
                  px-4
                  uppercase
                  font-semibold
                  text-sm
                "
              >
                Descripción
              </th>
              <th class="text-left py-3 px-4 uppercase font-semibold text-sm">
                Modificar
              </th>
              <th
                class="text-left py-3 px-4 uppercase font-semibold text-sm"
              ></th>
            </tr>
          </thead>
          <tbody class="text-gray-700 divide-y-2 border rounded">
            <tr
              class="bg-gray-100 hover:bg-white  divide
                divide-x
                divide-gray-200"
              :key="api.idconsecutivo"
              v-for="api in apis"
            >
              <td class="w-1/3 text-left py-3 px-4">
                {{ api.idconsecutivo }}
              </td>
              <td>
                {{ api.nombrecategoria }}
              </td>
              <td class="">
                <button
                  class="
                    text-black
                    mt-2
                    p-1
                    bg-blue-500
                    hover:bg-blue-400
                    border-light-blue-900
                    ring-2
                    rounded
                  "
                >
                  <a class="" href="#modalConsecutivo">
                    <img
                      width="30px"
                      src="https://image.flaticon.com/icons/png/512/61/61776.png"
                      alt=""
                    />
                  </a>
                </button>
              </td>
              <td class="">
                <button
                  class="
                    text-black
                    mt-2
                    p-1
                    hover:bg-red-400
                    b
                    border-light-red-300
                    bg-red-500
                    rounded
                  "
                >
                  <a>
                    <img
                      width="30px"
                      src="https://image.flaticon.com/icons/png/128/748/748023.png"
                      alt=""
                    />
                  </a>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  name: "tablaConsecutivo",
  data() {
    return {
      apis: "",
    };
  },
  computed: {
    ...mapState(["id", "descripcion", "numero"]),
  },
  mounted() {
    const token = this.numero;
    axios
      .get(
        "https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/Consecutivos",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        this.apis = response.data.data;
      })
         .catch((e) => {
            console.log(e);
            location.reload();
          });
  },
};
</script>
<style>
</style>